export default __webpack_public_path__ + "static/media/mail-line.1b61cf0c.svg";